import { useRef } from 'react';
import { useMarketParent } from '../../queries/useMarketParent';
import type { MarketParent } from 'shared/src/api';
import { Flex, Spinner, useScreenSize } from '@banhala/ui-kit';
import { useMarketNavigation } from '../../../../hooks/useMarketNavigation';

const shouldRedirectParentMarket = (
  market: MarketParent | undefined,
): market is {
  requested_market_sno: number;
  parent_market_sno: number;
} => {
  if (market == null) {
    return false;
  }

  const hasParent = market.parent_market_sno != null;
  const isNotRootMarket =
    market.parent_market_sno !== market.requested_market_sno;

  return hasParent && isNotRootMarket;
};

/** 부모 마켓 존재 시 부모 마켓으로 이동 */
export const MarketHomeParentMarketRedirectGuard = ({
  marketId,
  children,
}: {
  marketId: number;
  children: React.ReactNode;
}) => {
  /** 리다이렉션 중복 방지를 위한 참조 변수 */
  const hasRedirectedRef = useRef(false);

  const navigation = useMarketNavigation<'MarketHome'>();

  const {
    data: marketParent,
    isLoading: isLoadingMarketParent,
    isError: isErrorMarketParent,
  } = useMarketParent(marketId);

  if (isLoadingMarketParent) {
    return <MarketHomeParentMarketRedirectGuardSkeleton />;
  }

  if (isErrorMarketParent) {
    return <>{children}</>;
  }

  if (
    hasRedirectedRef.current === false &&
    shouldRedirectParentMarket(marketParent)
  ) {
    hasRedirectedRef.current = true;

    navigation.setParams({
      marketId: marketParent.parent_market_sno,
    });

    return null;
  }

  return <>{children}</>;
};

const MarketHomeParentMarketRedirectGuardSkeleton = () => {
  const { width } = useScreenSize();

  return (
    <Flex
      flex={1}
      width={width}
      padding={{ horizontal: 12 }}
      margin={{ horizontal: 'auto' }}
    >
      <Flex.Center flex={1}>
        <Spinner size={20} />
      </Flex.Center>
    </Flex>
  );
};
